import ReactDOM from 'react-dom/client';

//
import App from './App';
// import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// react-router, react18와 lightbox 충돌 방지
const consoleErrorFunc = window.console.error;
window.console.error = (...args: any) => {
  if (args[0]?.toString().includes('ResizeObserver')) return;
  consoleErrorFunc.apply(console, args);
};

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWAW
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
